import React from "react";
import { certificatesRepository } from "../../../repository/certificates.repository";
import TileItem from "../TileItem/TileItem";
import TileItemInfo from "../../molecules/TileItemInfo/TileItemInfo";
import TileItemImgInfo from "../../molecules/TileItemImgInfo/TileItemImgInfo";
import { languages } from "../../../dummyData/dummyData";

const CertificateTile = ({ data, skipUser, skipTeam }) => {
  const { selectableId, course_title, course_topic, prepared_teams, course_id, profile_image_small, user, download_ready, prepared_date, isChecked } = data;

  return (
    <TileItem title={course_title} image={profile_image_small} selectableId={selectableId} isChecked={isChecked} buttons={[
      {
        icon: "download",
        onClick: () => certificatesRepository.downloadCertificate(user.username, course_id),
        disabled: !download_ready,
        tooltip: download_ready ? `${languages.EN.labels.download} ${languages.EN.labels.certificate}` : languages.EN.labels.certificateBeingGenerated,
      },
    ]}>
      <TileItemInfo header={languages.EN.labels.learningArea} value={languages.EN.enums.learningAreas[course_topic]} />
      {!skipUser && <TileItemImgInfo header={languages.EN.labels.user} value={`${user.profile.name} ${user.profile.surname}`} image={user.profile.profile_image_small}/>}
      {!skipUser && <TileItemInfo header={languages.EN.labels.jobPosition} value={user.profile.user_job_position?.name} />}
      {!skipTeam && <TileItemInfo header={languages.EN.labels.team} value={prepared_teams} />}
      <TileItemInfo header={languages.EN.labels.obtained} value={prepared_date} />
    </TileItem>
  );
};

export default CertificateTile;
